import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default class VehicleMpProvider {
  public static async getPlayerVehicles(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehiclesResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehiclesRequest,
      typeof RegionShared.Backend.Responses.GetVehiclesResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehicles, {});
  }

  public static async getVehicleFuel(
    vehicleMpId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.GetVehicleFuelResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.GetVehicleFuelRequest,
      typeof RegionShared.Client.Responses.GetVehicleFuelResponse
    >(RegionShared.Client.Events.Vehicle.GetVehicleFuel, {
      vehicleMpId,
    });
  }

  public static async parkingReset(
    vehicleId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.VehicleParkingResetResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleParkingResetRequest,
      typeof RegionShared.Backend.Responses.VehicleParkingResetResponse
    >(RegionShared.Backend.Events.Vehicle.VehicleParkingReset, { vehicleId });
  }

  public static async parkingUpdate(
    data: typeof RegionShared.Backend.Requests.VehicleParkingUpdateRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.VehicleParkingUpdateResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleParkingUpdateRequest,
      typeof RegionShared.Backend.Responses.VehicleParkingUpdateResponse
    >(RegionShared.Backend.Events.Vehicle.VehicleParkingUpdate, data);
  }

  public static async characterDetach(
    vehicleId: number,
    characterId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.VehicleCharacterDetachResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleCharacterDetachRequest,
      typeof RegionShared.Backend.Responses.VehicleCharacterDetachResponse
    >(RegionShared.Backend.Events.Vehicle.VehicleCharacterDetach, { vehicleId, characterId });
  }

  public static async createTrade(
    vehicleId: number,
    characterId: number,
    price: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.VehicleTradeResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleTradeRequest,
      typeof RegionShared.Backend.Responses.VehicleTradeResponse
    >(RegionShared.Backend.Events.Vehicle.VehicleTrade, {
      characterId,
      vehicleId,
      price,
    });
  }

  public static async getVehiclesEstate(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehiclesEstateResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehiclesEstateRequest,
      typeof RegionShared.Backend.Responses.GetVehiclesEstateResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehiclesEstate, { estateId });
  }

  // TODO: deprecated
  public static async getVehicleEstate(
    vehicleId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehicleEstateResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehicleEstateRequest,
      typeof RegionShared.Backend.Responses.GetVehicleEstateResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehicleEstate, { vehicleId });
  }

  // TODO: новый метод вместо getVehicleEstate
  public static async getVehicleInfo(
    vehicleId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.VehicleGetInfoResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleGetInfoRequest,
      typeof RegionShared.Backend.Responses.VehicleGetInfoResponse
    >(RegionShared.Backend.Events.Garage.GetVehicleInfo, { vehicleId });
  }

  public static async getGarageVehicleInfo(
    data: typeof RegionShared.Backend.Requests.GarageGetVehicleInfoRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GarageGetVehicleInfoResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GarageGetVehicleInfoRequest,
      typeof RegionShared.Backend.Responses.GarageGetVehicleInfoResponse
    >(RegionShared.Backend.Events.Garage.GetVehicleInfo, data);
  }

  // TODO: depricated
  public static async getVehiclesRelated(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehiclesRelatedResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehiclesRelatedRequest,
      typeof RegionShared.Backend.Responses.GetVehiclesRelatedResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehiclesRelated, {});
  }

  // TODO: новый вместо getVehiclesRelated
  public static async getRelated(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.VehicleGetRelatedResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleGetRelatedRequest,
      typeof RegionShared.Backend.Responses.VehicleGetRelatedResponse
    >(RegionShared.Backend.Events.VehicleV3.GetRelated, {});
  }

  public static async getVehiclesOfferCreator(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehiclesOfferResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehiclesOfferRequest,
      typeof RegionShared.Backend.Responses.GetVehiclesOfferResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehiclesOffer, {});
  }

  public static async getVehicleOfferResolver(
    vehicleId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehicleOfferResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehicleOfferRequest,
      typeof RegionShared.Backend.Responses.GetVehicleOfferResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehicleOffer, { vehicleId });
  }

  public static async getVehiclesComplexRequest(
    data: typeof RegionShared.Backend.Requests.GetVehiclesComplexRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetVehiclesComplexResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetVehiclesComplexRequest,
      typeof RegionShared.Backend.Responses.GetVehiclesComplexResponse
    >(RegionShared.Backend.Events.Vehicle.GetVehiclesComplex, data);
  }

  public static async vehicleComplexSummon(
    data: typeof RegionShared.Backend.Requests.VehicleComplexSummonRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.VehicleComplexSummonResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehicleComplexSummonRequest,
      typeof RegionShared.Backend.Responses.VehicleComplexSummonResponse
    >(RegionShared.Backend.Events.Vehicle.VehicleComplexSummon, data);
  }

  public static async getMyGarageInfo(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GarageGetMyResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GarageGetMyRequest,
      typeof RegionShared.Backend.Responses.GarageGetMyResponse
    >(RegionShared.Backend.Events.Garage.GetMy, {});
  }

  public static async getGarageInfo(
    data: typeof RegionShared.Backend.Requests.GarageGetRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GarageGetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GarageGetRequest,
      typeof RegionShared.Backend.Responses.GarageGetResponse
    >(RegionShared.Backend.Events.Garage.Get, data);
  }

  public static async putIntoGarage(
    data: typeof RegionShared.Backend.Requests.VehiclePutIntoGarageRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.VehiclePutIntoGarageResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.VehiclePutIntoGarageRequest,
      typeof RegionShared.Backend.Responses.VehiclePutIntoGarageResponse
    >(RegionShared.Backend.Events.VehicleV3.PutIntoGarage, data);
  }

  public static async clearLotGarage(
    data: typeof RegionShared.Backend.Requests.GarageClearLotRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GarageClearLotResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GarageClearLotRequest,
      typeof RegionShared.Backend.Responses.GarageClearLotResponse
    >(RegionShared.Backend.Events.Garage.ClearLot, data);
  }
}
